import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import FileBase64 from "../../components/Upload/UploadFile";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import Layout from "../../components/Wrappers/Layout";
import Util from "../../validation";

import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { Row, Col, Card, Alert } from "reactstrap";
import BackButton from "../../components/BackButton/BackButton";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { updateKycLabelList } from "../../redux/actions/updateKycLabelPartnerAction";
import { getKycLabelLists } from "../../redux/actions/getKycLabelPartnerAction"

const KycLevel = () => {
    const [basicLevel, setBasicLevel] = useState('')
    const [premiumLevel, setPremiumLevel] = useState('')
    const [standardLevel, setStandardLevel] = useState('');
    const [supremeLevel, setSupremeLevel] = useState('')
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    var authToken = regenerateTokenRes.data.AuthToken;

    const dispatch = useDispatch();
    const [getUpdateKycLabelStatus, setGetUpdateKycLabelStatus] =
        useState(false);
    const [getUpdateKYCLabelsRes, setGetUpdateKYCLabelsRes] =
        useState('');

    const getUpdateKYCLabelRes = useSelector(
        ({ partnerUpdateKYCLabelLists }) => partnerUpdateKYCLabelLists
    );
    const getKYCLabelRes = useSelector(
        ({ partnerGetKYCLablesLists }) => partnerGetKYCLablesLists
    );

    const handleNoticationClose = () => {
        setNotificationOpen(false);
    };
    const handleChange = ({ target: { name, value } }) => {
        // if (name === "basicLevel") {
        //     setBasicLevel(value);
        // }
        if (name === "basicLevel") {
            // setBankName(value);
            Util.alphaNumeric(value) ? setBasicLevel(value) : setBasicLevel(basicLevel);
        }

        if (name === "premiumLevel") {
            // setPremiumLevel(value);
            Util.alphaNumeric(value) ? setPremiumLevel(value) : setPremiumLevel(premiumLevel);
        }
        if (name === "standardLevel") {
            // setStandardLevel(value);
            Util.alphaNumeric(value) ? setStandardLevel(value) : setStandardLevel(standardLevel);

        }

        if (name === "supremeLevel") {
            // setSupremeLevel(value);
            Util.alphaNumeric(value) ? setSupremeLevel(value) : setSupremeLevel(supremeLevel);

        }

    };

    useEffect(() => {
        if (getKYCLabelRes.data.status == "success") {
            setBasicLevel(
                getKYCLabelRes.data.kycLabelList.basicLabel
            );
            setPremiumLevel(getKYCLabelRes.data.kycLabelList.premiumLabel);
            setStandardLevel(
                getKYCLabelRes.data.kycLabelList.standardLabel
            );
            setSupremeLevel(getKYCLabelRes.data.kycLabelList.supremeLabel);



        }
    }, [getKYCLabelRes.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getKYCLabelReqsListApi();
        }
    }, [regenerateTokenRes.data.status]);
    const getKYCLabelReqsListApi = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || ""
            }
        };
        return dispatch(getKycLabelLists(req, authToken));
    };

    useEffect(() => {
        if (getUpdateKycLabelStatus) {
            if (getUpdateKYCLabelRes.data.status == "success") {
                setGetUpdateKYCLabelsRes(getUpdateKYCLabelRes.data);
                setNotificationOpen(true);
                getKYCLabelReqsListApi()

            }
            if (getUpdateKYCLabelRes.data.status == "Failed") {
                setGetUpdateKYCLabelsRes(getUpdateKYCLabelRes.data);
                setNotificationOpen(true);
                if (
                    getUpdateKYCLabelRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getUpdateKYCLabelRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getUpdateKYCLabelRes.data.status == "failed") {
                setGetUpdateKYCLabelsRes(getUpdateKYCLabelRes.data);
                setNotificationOpen(true);
                if (
                    getUpdateKYCLabelRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getUpdateKYCLabelRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }, [getUpdateKYCLabelRes.data.status]);

    const updateKYCLabelAPI = () => {
        setGetUpdateKycLabelStatus(true)
        const updateKycLabelReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                basicLabel: basicLevel,
                standardLabel: standardLevel,
                premiumLabel: premiumLevel,
                supremeLabel: supremeLevel
            }
        }
        // console.log("reqqqqq", updateKycLabelReq)
        return dispatch(updateKycLabelList(updateKycLabelReq, authToken));

    }
    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center tableHeaderColor"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> KYC Display Labels </Typography>
                            </Alert>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField
                                // autoFocus
                                margin="dense"
                                label="Basic Label"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="basicLevel"
                                value={basicLevel}
                                onChange={handleChange}
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField
                                // autoFocus
                                margin="dense"
                                label="Standard Label"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="standardLevel"
                                value={standardLevel}
                                onChange={handleChange}
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField
                                // autoFocus
                                margin="dense"
                                label="Premium Label"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="premiumLevel"
                                value={premiumLevel}
                                onChange={handleChange}
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField
                                // autoFocus
                                margin="dense"
                                label="Supreme Label"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="supremeLevel"
                                value={supremeLevel}
                                onChange={handleChange}
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
                            />
                        </Grid>

                        {/* <div className="text-center" style={{ marginTop: "2.5rem" }}>


                            <CustomButton
                                style={{
                                    padding: "8px",
                                    // marginLeft: "0.7rem",
                                    margin: "0 8px"
                                }}
                                variant="contained"
                            // onClick={addUserDsrListFunc}
                            >
                                Save
                                <SaveIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </div> */}
                        <Grid item xs={12} sm={12} md={12} lg={12}>

                            <div
                                style={{
                                    margin: "20px",
                                    textAlign: "center"
                                }}
                            >
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    onClick={updateKYCLabelAPI}
                                >
                                    Save
                                    <SaveIcon style={{ marginLeft: "4px", fontSize: "21px" }} />

                                </CustomButton>
                            </div>
                        </Grid>

                    </Grid>
                </Card>
            </Layout>

            {getUpdateKYCLabelsRes.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getUpdateKYCLabelsRes.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getUpdateKYCLabelsRes.status == "Failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getUpdateKYCLabelsRes.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default KycLevel